import tw, { styled } from 'twin.macro';

import { Wrapper } from '../../core-ui/Wrapper';

export const ProjectSliceWrapper = styled(Wrapper)`
  ${tw`w-full lg:w-10/12 mx-auto`}
`;
